module.exports = __webpack_public_path__ + "media/images/weather/341_night-3c6553c2cc7d47070f7e7d2b7b49f0ea.png";